module.exports = __webpack_public_path__ + "static/media/14UNEP2.c7b767be.jpg";